import { Component, inject, input } from '@angular/core';
import { ReportDetailedRowDto, ReportRequestDto, ReportsService, TotalsDto } from '../../../../api';
import {ReportsSummaryHeaderComponent} from '../reports-summary-header/reports-summary-header.component';
import {Divider} from 'primeng/divider';
import {DetailedReportTableComponent} from './detailed-report-table/detailed-report-table.component';
import {ReportActionsComponent} from '../report-actions/report-actions.component';
import {ExportFormat} from '../../model/ExportFormat';

@Component({
  selector: 'app-detailed-report',
  imports: [
    ReportsSummaryHeaderComponent,
    Divider,
    DetailedReportTableComponent,
    ReportActionsComponent,
  ],
  templateUrl: './detailed-report.component.html',
  styleUrl: './detailed-report.component.css',
})
export class DetailedReportComponent {
  private reportsService = inject(ReportsService);

  isOwner = input.required<boolean>();
  totals = input.required<TotalsDto>();
  tableData = input.required<Array<ReportDetailedRowDto>>();
  reportRequest = input.required<ReportRequestDto>();

  downloadDetailedReport = (workspaceId: string, format: ExportFormat, request: ReportRequestDto) => {
    return this.reportsService.detailedReportExport(workspaceId, format, request, 'response');
  };
}
